import { forwardRef } from 'react';
import MuiAlert from '@mui/material/Alert';
import type { AlertProps as MuiAlertProps } from '@mui/material/Alert';

/** Alias direto do MUI: nenhuma das quatro severidades do projeto diverge do default do componente. */
export type AlertProps = MuiAlertProps;

/** Alerta do design system: mesmo tipo/ref/estrutura de pasta dos demais átomos sem default de aparência a fixar. */
export const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert ref={ref} {...props} />;
});
